import React from 'react';
import { Icon } from './Icon.js';
export const IconArrowBoldLeftFromLine = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M21 15L21 9", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M3 12L12.5 20L13 20L13 15L17 15L17 9L13 9L13 4L12.5 4L3 12Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconArrowBoldLeftFromLine.js.map